import {
  bannerMaterialSrc,
  getActiveBannerSlides,
} from "../pages/productInformation/productInformationData";

export { bannerMaterialSrc };

export interface BannerSwiperImage {
  name: string;
  title: string;
  productPath: string;
}

/** Derived from campaign catalog (newest {@link BANNER_DISPLAY_COUNT} only). */
export const bannerSwiperImages: BannerSwiperImage[] = getActiveBannerSlides();
